import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { EstablishmentService } from '../../../../../services/establishment.service';
import { SharedModule } from '../../../../../shared/shared.module';

@Component({
  selector: 'app-second-step-add-candidate',
  standalone: true,
  imports: [CommonModule, SharedModule, ReactiveFormsModule],
  templateUrl: './second-step-add-candidate.component.html',
  styleUrl: './second-step-add-candidate.component.scss'
})
export class SecondStepAddCandidateComponent implements OnInit {
  @Input() form!: FormGroup;
  @Input() loading = false;
  @Output() formValid = new EventEmitter<boolean>();

  disponibilityOptions = [
    { value: 'immediate', label: 'Immédiate' },
    { value: 'one_week', label: 'Dans une semaine' },
    { value: 'two_weeks', label: 'Dans deux semaines' },
    { value: 'one_month', label: 'Dans un mois' }
  ];

  disponibilityDateOptions = [
    { value: 'full_time', label: 'Temps plein' },
    { value: 'part_time', label: 'Temps partiel' },
    { value: 'weekends', label: 'Week-ends' },
    { value: 'nights', label: 'Nuits' }
  ];

  mobilityOptions = [
    { value: '10', label: '10 km' },
    { value: '20', label: '20 km' },
    { value: '30', label: '30 km' },
    { value: '50', label: '50 km' },
    { value: '100', label: '100 km' }
  ];

  transportOptions = [
    { value: 'car', label: 'Voiture' },
    { value: 'public_transport', label: 'Transport en commun' },
    { value: 'bike', label: 'Vélo' },
    { value: 'walk', label: 'À pied' }
  ];

  addressList: any[] = [];

  constructor(private fb: FormBuilder, private establishmentService: EstablishmentService, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.initForm();
    this.form.statusChanges.subscribe(() => {
      setTimeout(() => this.formValid.emit(this.form.valid));
      this.cdr.detectChanges();
    });
  }

  private initForm(): void {
    this.form.addControl('address', this.fb.control('', Validators.required));
    this.form.addControl('postalcode', this.fb.control('', [
      Validators.required,
      Validators.pattern('^[0-9]{4,5}$')
    ]));
    this.form.addControl('city', this.fb.control('', Validators.required));
    this.form.addControl('country', this.fb.control('France', Validators.required));
    this.form.addControl('disponibilite', this.fb.control('', Validators.required));
    this.form.addControl('disponibilitedate', this.fb.control('', Validators.required));
    this.form.addControl('mobilite', this.fb.control('', Validators.required));
    this.form.addControl('transport', this.fb.control('', Validators.required));
  }

  autoCompleteOnChange(event: any) {
    const value = event?.target?.value || event;
    this.getAddresses(value);
  }

  onAddressSelected(value: string) {
    const selectedAddress = this.addressList.find(
      (address) => this.getAdresseFormated(address) === value
    );
    if (selectedAddress) {
      this.addressSelected(selectedAddress);
    }
  }

  getAdresseFormated(option: any) {
    const address = option?.address || {};
    const house_number = address?.house_number || '';
    const road = address?.road || '';
    const postcode = address?.postcode || '';
    const city = address?.city || '';
    const country = address?.country || '';
    const addressComponents = [
      house_number,
      road,
      `${postcode} ${city}`,
      country
    ];
    const filteredComponents = addressComponents.filter(component => component.trim() !== '');
    return filteredComponents.join(', ');
  }

  getAddresses(wordKey: string) {
    this.form.get('address')?.markAsTouched();
    this.form.get('postalcode')?.markAsTouched();
    if (wordKey) {
      this.establishmentService
        .getAddress(wordKey, 'france')
        .subscribe((value) => {
          this.addressList = value.filter(
            (value: any) => value.address.country_code === 'fr'
          );
        });
    } else {
      this.form.get('address')?.patchValue('');
      this.form.get('postalcode')?.patchValue('');
      this.form.get('regionName')?.patchValue('');
      this.form.get('regionCode')?.patchValue('');
      this.form.markAsTouched();
    }
  }

  addressSelected(item: any): void {
    const address = item?.address || {};
    this.form.get('lat')?.patchValue(item.lat);
    this.form.get('lon')?.patchValue(item.lon);
    this.form.get('address')?.patchValue(this.getAdresseFormated(item));
    this.form.get('postalcode')?.patchValue(address.postcode);
    this.form.get('country')?.patchValue(address.country);
    this.form.get('city')?.patchValue(address.city);
    // Département = county (e.g. "Ain"), not the city (e.g. "Bourg-en-Bresse").
    this.form.get('departmentName')?.patchValue(address.county || address.city);
    if (!address.postcode) {
      return;
    }
    this.establishmentService
      .getRegionByPostalCode(address.postcode)
      .subscribe({
        next: (res) => {
          const code = res?.[0]?.codeRegion;
          if (!code) {
            return;
          }
          this.form.get('regionCode')?.patchValue(code);
          this.establishmentService
            .getRegionByCode(code)
            .subscribe({
              next: (region) => {
                this.form.get('regionName')?.patchValue(region?.nom || '');
              },
              error: () => {},
            });
        },
        error: () => {},
      });
  }
}
